import React from "react";
// import { useNavigate } from "react-router-dom";
// import { useMsal } from "@azure/msal-react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Downloads from "../../components/Downloads/FileDownloadPage";
 
 
const DownloadsPage: React.FC = () => {
    return (
      <div className="flex flex-col min-h-screen bg-[#F7F7FF]">
      <div className="flex-grow  ">
        <Header />
       
        <main >
        <Downloads/>
        </main>
        </div>
        <Footer />
       
      </div>
    );
  };
 
  export default DownloadsPage;